import * as React from "react";
import { forwardRef } from "react";
const SvgChevronPrev = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path fill="currentColor" fillRule="nonzero" d="M9.59 2 11 3.41 6.42 8 11 12.59 9.59 14l-6-6z" /><path d="M16 0H0v16h16z" /></g></svg>;
const ForwardRef = forwardRef(SvgChevronPrev);
export { ForwardRef as ReactComponent };